const CONTEXT_FIELD_ID = "HiddenFieldCustomerContextID";
const LEGACY_FRAME_SELECTOR = 'iframe[data-testid="legacy-frame"]';

const readFrameCustomerId = (): string | null => {
  try {
    const frame = document.querySelector<HTMLIFrameElement>(LEGACY_FRAME_SELECTOR);
    const field = frame?.contentDocument?.getElementById(CONTEXT_FIELD_ID) as HTMLInputElement | null | undefined;
    return field?.value || null;
  } catch {
    return null;
  }
};

const readUrlCustomerId = (): string | null => new URLSearchParams(window.location.search).get("customerid");

export const getCustomerContextId = (): string | null => readFrameCustomerId() ?? readUrlCustomerId();
